﻿declare const dataLayer: any;

export const addPromotionClick = (input: any) =>
{
    var dataHolder = $(input).parent();

    var id = $(dataHolder).data("id");
    var name = $(dataHolder).data("name");
    var creative = $(dataHolder).data("creative");
    var position = $(dataHolder).data("position");

    sendDataLayer({ ecommerce: null });
    sendDataLayer({
        "event": "promotionClick",
        "ecommerce": {
            "items": [{
                "promotion_id": id,
                "promotion_name": name,
                "creative_name": creative,
                "creative_slot": position
            }]
        }
    });
};

(window as any).addPromotionClick = addPromotionClick;

export const sendDataLayer = (input: any) =>
{
    dataLayer.push(input);
};

declare const categoryTree;

export const getProductDetailImpression = (selector?: HTMLElement | null) =>
{
    var impressionItems = {};
    let productDetail;

    if (selector)
        productDetail = $(selector);
    else
        productDetail = $(".js-article-data");

    if (productDetail)
    {
        var breadcrumbs = getBreadCrumbImpression();
        var sku = productDetail.data("sku");
        var name = productDetail.data('name');
        var brand = productDetail.data("brand");
        var price = productDetail.data("price");
        var variant = productDetail.data("variant");
        var discount = productDetail.data("discount");
        var color = productDetail.data("color");
        var size = productDetail.data("size");
        var livingstyle = productDetail.data("livingstyle");
        var priceclass = productDetail.data("priceclass");
        var material = productDetail.data("material");
        var stuffing = productDetail.data("stuffing");
        var season = productDetail.data("season");
        var deliverytime = productDetail.data("deliverytime");
        var articlenumber = productDetail.data("articlenumber");
        var sleepingposition = productDetail.data("sleepingposition");
        var firmness = productDetail.data("firmness");
        var stock = productDetail.data("stock");
        var type = productDetail.data("type");
        var thermalclass = productDetail.data("thermalclass");

        var categoryItem = breadcrumbs['item2'];
        var listName = location.pathname;

        if (typeof (categoryTree) !== typeof (undefined) &&
            categoryTree != '')
        {
            categoryItem = categoryTree;
            listName = '/' + categoryTree.toLowerCase() + '/';
        }

        var items = {};
        if (name != '')
            items['item_name'] = name;
        if (sku != '')
            items['item_id'] = sku;
        if (price != '')
            items['price'] = price;
        if (discount != '')
            items['discount'] = discount;
        items['currency'] = 'EUR';
        if (brand != '')
            items['item_brand'] = brand;
        if (categoryItem != '')
            items['item_category'] = categoryItem;
        if (breadcrumbs['item3'] != '')
            items['item_category2'] = breadcrumbs['item3'];
        if (breadcrumbs['item4'] != '')
            items['item_category3'] = breadcrumbs['item4'];
        if (breadcrumbs['item5'] != '')
            items['item_category4'] = breadcrumbs['item5'];
        if (breadcrumbs['item6'] != '')
            items['item_category5'] = breadcrumbs['item6'];
        if (variant != '')
            items['item_variant'] = variant;
        if (color != '')
            items['item_color'] = color;
        if (size != '')
            items['item_size'] = size;
        if (livingstyle != '')
            items['item_woonstijl'] = livingstyle;
        if (priceclass != '')
            items['item_prijsklasse'] = priceclass;
        if (material != '')
            items['item_materiaal'] = material;
        if (stuffing != '')
            items['item_vulling'] = stuffing;
        if (season != '')
            items['item_seizoen'] = season;
        if (deliverytime != '')
            items['item_levertijd'] = deliverytime;
        if (articlenumber != '')
            items['item_smulcode'] = articlenumber;
        if (sleepingposition != '')
            items['item_slaaphouding'] = sleepingposition;
        if (firmness != '')
            items['item_stevigheid'] = firmness;
        if (stock != '')
            items['item_voorraad'] = stock;
        if (type != '')
            items['item_type'] = type;
        if (thermalclass != '')
            items['item_warmteklasse'] = thermalclass;
        items['item_list_id'] = '1';
        items['item_list_name'] = listName;
        items['index'] = 1;
        items['quantity'] = '1';
        items['google_business_vertical'] = 'retail';

        var impressionItems = items;
    }

    return impressionItems;
}

export const getBreadCrumbImpression = () =>
{
    var breadcrumbholder = $('.c-breadcrumbs__link');

    var breadcrumbs = {}; breadcrumbs['item1'] = 'Home';
    breadcrumbs['item2'] = '';
    breadcrumbs['item3'] = '';
    breadcrumbs['item4'] = '';
    breadcrumbs['item5'] = '';
    breadcrumbs['item6'] = '';

    if (breadcrumbholder.length > 0)
    {
        var i = 1;
        breadcrumbholder.each(function ()
        {
            var breadcrumbTitle = $(this).attr('title');
            if (typeof (breadcrumbTitle) !== 'undefined' && breadcrumbTitle != null && breadcrumbTitle != '')
            {
                breadcrumbs['item' + i] = breadcrumbTitle;
                i++;
            }
        });
    }

    return breadcrumbs;
}

const addAdditionalEcommProduct = (obj) =>
{
    var dataHolder = $(obj).parent();

    if (dataHolder.hasClass("related-article"))
        dataHolder = dataHolder.parent();

    var sku = $(dataHolder).data("sku");
    var name = $(dataHolder).data("name");
    var brand = $(dataHolder).data("brand");
    var category = $(dataHolder).data("category");
    var price = $(dataHolder).data("price");
    var priceexvat = $(dataHolder).data("priceexvat");
    var variant = $(dataHolder).data("variant");
    var list = $(dataHolder).data("list");

    sendDataLayer({
        'event': 'basketadd',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}
(window as any).addAdditionalEcommProduct = addAdditionalEcommProduct;

const addListArticleClick = (obj) =>
{
    var dataHolder;

    if ($(obj).hasClass("js-article-event"))
        dataHolder = $(obj);
    else if ($(obj).hasClass("js-article-data"))
        dataHolder = $(obj);
    else if ($(obj).closest(".js-article-data").length > 0)
        dataHolder = $(obj).closest(".js-article-data");
    else if ($(obj).parent().hasClass(".slide"))
        dataHolder = $(obj).parent();
    else if ($(obj).closest(".featureditem").length > 0)
        dataHolder = $(obj).closest(".featureditem");
    else
        dataHolder = $(obj).parent();

    var sku = $(dataHolder).data("sku");
    var name = $(dataHolder).data("name");
    var brand = $(dataHolder).data("brand");
    var category = $(dataHolder).data("category");
    var price = $(dataHolder).data("price");
    var priceexvat = $(dataHolder).data("priceexvat");
    var variant = $(dataHolder).data("variant");
    var position = $(dataHolder).data("position");
    var list = $(dataHolder).data("list");
    var discount = $(dataHolder).data("discount");
    var color = $(dataHolder).data("color");
    var size = $(dataHolder).data("size");
    var livingstyle = $(dataHolder).data("livingstyle");
    var priceclass = $(dataHolder).data("priceclass");
    var material = $(dataHolder).data("material");
    var stuffing = $(dataHolder).data("stuffing");
    var season = $(dataHolder).data("season");
    var deliverytime = $(dataHolder).data("deliverytime");
    var articlenumber = $(dataHolder).data("articlenumber");
    var sleepingposition = $(dataHolder).data("sleepingposition");
    var firmness = $(dataHolder).data("firmness");
    var stock = $(dataHolder).data("stock");
    var type = $(dataHolder).data("type");
    var thermalclass = $(dataHolder).data("thermalclass");

    $.stash.set('listname', list);

    // Name is required.
    if (typeof name !== "undefined")
    {
        var breadcrumbs = getBreadCrumbImpression();
        var items = {};
        if (name != '')
            items['item_name'] = name;
        if (sku != '')
            items['item_id'] = sku;
        if (price != '')
            items['price'] = price;
        if (discount != '')
            items['discount'] = discount;
        items['currency'] = 'EUR';
        if (brand != '')
            items['item_brand'] = brand;
        if (category != '')
            items['item_category'] = category;
        if (breadcrumbs['item3'] != '')
            items['item_category2'] = breadcrumbs['item3'];
        if (breadcrumbs['item4'] != '')
            items['item_category3'] = breadcrumbs['item4'];
        if (breadcrumbs['item5'] != '')
            items['item_category4'] = breadcrumbs['item5'];
        if (breadcrumbs['item6'] != '')
            items['item_category5'] = breadcrumbs['item6'];
        if (variant != '')
            items['item_variant'] = variant;
        if (color != '')
            items['item_color'] = color;
        if (size != '')
            items['item_size'] = size;
        if (livingstyle != '')
            items['item_woonstijl'] = livingstyle;
        if (priceclass != '')
            items['item_prijsklasse'] = priceclass;
        if (material != '')
            items['item_materiaal'] = material;
        if (stuffing != '')
            items['item_vulling'] = stuffing;
        if (season != '')
            items['item_seizoen'] = season;
        if (deliverytime != '')
            items['item_levertijd'] = deliverytime;
        if (articlenumber != '')
            items['item_smulcode'] = articlenumber;
        if (sleepingposition != '')
            items['item_slaaphouding'] = sleepingposition;
        if (firmness != '')
            items['item_stevigheid'] = firmness;
        if (stock != '')
            items['item_voorraad'] = stock;
        if (type != '')
            items['item_type'] = type;
        if (thermalclass != '')
            items['item_warmteklasse'] = thermalclass;
        items['item_list_id'] = '1';
        items['item_list_name'] = list;
        if (position != '')
            items['index'] = position;
        items['quantity'] = '1';
        items['google_business_vertical'] = 'retail';

        sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
        sendDataLayer({
            'event': 'productClick',
            'ecommerce': {
                'items': [items]
            }
        });
    }
}

(window as any).addListArticleClick = addListArticleClick;


const addMenuProductClick = (obj) =>
{
    $.stash.remove('lastCategoryUrl');
}

(window as any).addMenuProductClick = addMenuProductClick;

(window as any).sendDataLayer = sendDataLayer;
(window as any).getProductDetailImpression = getProductDetailImpression;
(window as any).getBreadCrumbImpression = getBreadCrumbImpression;

const actionSend = [];

const initEcommerceEvents = () =>
{
    if ($(".js-article-event").length > 0)
    {
        $(".js-article-event").each(function (index, item)
        {
            onScrolledIntoView($(item), function ()
            {
                const listName = $(item).data("list") ?? location.pathname;

                if (!actionSend.includes(listName))
                {
                    sendDataLayer({
                        'event': 'productView',
                        'category': 'Ecommerce',
                        'action': location.pathname
                    });
                    actionSend.push(listName);
                }

                sendDataLayer({
                    'event': 'productView',
                    'ecommerce': {
                        'items': [getProductDetailImpression(item)]
                    }
                });
            });

            $(item).find("a").on("click", function ()
            {
                sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
                sendDataLayer({
                    'event': "productClick",
                    'ecommerce': {
                        'impressions': [{
                            'name': $(item).data("name"),       // Name or ID is required.
                            'price': $(item).data("price"),
                            'brand': $(item).data("brand"),
                            'category': $(item).data("category"),
                            'variant': $(item).data("variant"),
                            'list': $(item).data("list"),
                            'position': $(item).data("position")
                        }]
                    }
                });
            });
        });
    }
}

const initAccountEvents = () =>
{
    if ($('#newCustomer').length > 0 &&
        $('#newCustomer').val() != null &&
        typeof ($('#newCustomer').val()) != typeof (undefined)
    )
    {
        sendDataLayer({ 'newCustomer': $('#newCustomer').val() });
    }

    if ($('#accountStatus').length > 0 &&
        $('#accountStatus').val() != null &&
        typeof ($('#accountStatus').val()) != typeof (undefined)
    )
    {
        sendDataLayer({ 'Account': $('#accountStatus').val() });
    }
};

const initFooterEvents = () =>
{
    $(".c-newsletter__button").on('click', function ()
    {
        sendDataLayer({
            'event': 'newsletterOptin',
            'newsletterlocation': 'footer'
        });
    });
};

const initActionboxEvents = () =>
{
    if ($(".w-actionbox__link").length > 0)
    {
        $(".w-actionbox__link").each(function (index, item)
        {
            onScrolledIntoView($(item), function ()
            {
                var dataHolder = $(item).parent();

                var id = $(dataHolder).data("id");
                var name = $(dataHolder).data("name");
                var creative = $(dataHolder).data("creative");
                var position = $(dataHolder).data("position");

                sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
                sendDataLayer({
                    'event': 'promotionView',
                    'ecommerce': {
                        'items': [{										// Array of promoFieldObjects.
                            'promotion_id': id,		                    // ID or Name is required.
                            'promotion_name': name,
                            'creative_name': creative,
                            'creative_slot': position
                        }]
                    }
                });
            });
        });
    }
}

if (!(window as any).initEcommerceEvents)
{
    (window as any).initEcommerceEvents = true;
    document.addEventListener("DOMContentLoaded", () =>
    {
        initEcommerceEvents();
        initAccountEvents();
        initFooterEvents();
        initActionboxEvents();
    });
}
